module.exports = __webpack_public_path__ + "static/media/icon-pencil-hover.1da889c1.svg";